import { AfterViewInit, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AssignedRole } from 'src/app/models/data/assignedRole';
import { UserProfile } from 'src/app/models/model';
import { AuthService } from 'src/app/services/auth.service';
import { EventService, EventServiceType } from 'src/app/services/event.service';
import { LoadingIndicatorService } from '../services/loading-indicator.service';
import { NavigationHistoryService } from '../services/navigation-history.service';
import { UserProfileService } from '../services/user-profile.service';
import { MatButton } from '@angular/material/button';
import { MatActionList, MatListItem, MatDivider } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { TOSAndPrivacyPolicyComponent } from '../terms-of-use-and-privacy-policy/tos-and-privacy-policy.component';

export const CHANGE_ROLE_LOADING_KEY =
	'NAV_PROFILE_INFORMATION_CHANGE_ROLE_LOADING_KEY';
@Component({
	selector: 'app-profile-information',
	templateUrl: './nav-profile-information.component.html',
	styleUrls: [
		'./nav-profile-information.component.scss',
		'./nav.component.scss',
		'../ui/common/main.scss',
	],
	imports: [
		MatButton,
		MatActionList,
		MatListItem,
		MatIcon,
		MatDivider,
		TOSAndPrivacyPolicyComponent,
	],
})
export class NavProfileInformationComponent implements AfterViewInit {
	closeMenuText = $localize`:@@navComponent-closeMenu:Close menu`;
	loadingProfile = true;

	get userName(): string {
		const user = this.userProfile.user;
		return `${user.firstName} ${user.lastName}`;
	}

	get userInitials(): string {
		const user = this.userProfile.user;
		return `${user.firstName.substring(0, 1)}${user.lastName.substring(0, 1)}`;
	}

	get email(): string {
		return this.userProfile.user.email;
	}

	constructor(
		public dialogRef: MatDialogRef<NavProfileInformationComponent>,
		public authService: AuthService,
		public eventService: EventService,
		public router: Router,
		private profileService: UserProfileService,
		private navHistory: NavigationHistoryService,
		private readonly loadingService: LoadingIndicatorService,
		@Inject(MAT_DIALOG_DATA) public userProfile: UserProfile
	) {}

	async ngAfterViewInit(): Promise<void> {
		this.userProfile = await this.profileService.getUserProfile();
		this.loadingProfile = false;
	}

	onEditAccountClick(): void {
		this.dialogRef.close();
		this.router.navigateByUrl('/profile', { state: { name: 'User Profile' } });
	}

	async onRoleSelected(role: AssignedRole): Promise<void> {
		this.dialogRef.close(role);

		const activeEntityRelationshipId =
			this.userProfile.activeRoleDetails?.entityRelationship.id;
		if (role.entityRelationshipId === activeEntityRelationshipId) {
			return;
		}

		this.navHistory.clearHistory(0);
		this.navHistory.clearLastNavigationItemClicked();

		this.loadingService.start(CHANGE_ROLE_LOADING_KEY);
		try {
			await this.authService.updateCustomClaims(role.entityRelationshipId);
			this.eventService.emitEvent(EventServiceType.refreshNav);
			await this.router.navigateByUrl('/');
		} catch (err) {
			this.logout();
		} finally {
			this.loadingService.stop(CHANGE_ROLE_LOADING_KEY);
		}
	}

	onSignOutClicked(): void {
		this.dialogRef.close();
		this.logout();
	}

	private async logout(): Promise<void> {
		this.profileService.clearUserProfile();
		await this.authService.logout();
		await this.router.navigateByUrl('/login');
	}
}
